import { SMARTBRIEF_ROOT, NEWSLETTER_ROOT, CAMPAIGN_TAG } from "../constants";
import { Brief, SubscriberId } from "../../app/services/subscriberFeedbackApi";

const UNSUBSCRIBE_REASON: string = "FEEDBACK";

export type LinkItem = {
    text: string;
    key: string;
    href: string;
};

export type Card = {
    title: string;
    links: LinkItem[];
};

export function subscriptionCard(brief: Brief | undefined, subscriberId: SubscriberId): Card {
    return {
        title: "I need help managing my subscriptions...",
        links: [
            {
                text: "Resubscribe me",
                key: "resubscribe",
                href: `${NEWSLETTER_ROOT}/${brief?.name}?campaign=` + CAMPAIGN_TAG,
            },
            {
                text: "I want to unsubscribe",
                key: "unsubscribe",
                href: `${NEWSLETTER_ROOT}/UnSubscribe.jsp?b=${brief?.name}&sid=${subscriberId}&rc=${UNSUBSCRIBE_REASON}`,
            },
        ],
    };
}

export function updateInfoCard(brief: Brief | undefined, subscriberId: SubscriberId): Card {
    return {
        title: "I would like to update my information...",
        links: [
            {
                text: "Update Email Address",
                key: "updateEmail",
                href: `${NEWSLETTER_ROOT}/changeEmail.jsp?sid=${subscriberId}`,
            },
            {
                text: "Update my profile",
                key: "uyd",
                href: `${NEWSLETTER_ROOT}/uyd/updateAccount.action?briefName=${brief?.name}&subscriberid=${subscriberId}`,
            },
        ],
    };
}

export function legalCard(): Card {
    return {
        title: "I have a question about policy...",
        links: [
            {
                text: "Terms of Use",
                key: "terms",
                href: "https://www.futureplc.com/terms-conditions/",
            },
            {
                text: "Privacy Policy",
                key: "privacy",
                href: `${SMARTBRIEF_ROOT}/privacy-cookie-policy`,
            },
        ],
    };
}
